'use strict';

// TODO create a directive for managing config and order tabs
module.exports = ['$scope', '$location', 'PlantSvc', 'PermissionSvc', function ($scope, $location, PlantSvc, PermissionSvc) {
    var DEFAULT_REPORT = 'dayview';

    // ------------------
    // scope functions
    // ------------------
    $scope.isPlantSelected = function (plant_id) {
        return $scope.selectedPlants.indexOf(plant_id) > -1;
    };

    $scope.togglePlantSelected = function (plant_id) {
        var index = $scope.selectedPlants.indexOf(plant_id);
        if (index > -1) {
            $scope.selectedPlants.splice(index, 1);
        } else {
            $scope.selectedPlants.push(plant_id);
        }
    };

    $scope.toggleAllPlantSelected = function () {
        if ($scope.selectedPlants.length) {
            $scope.selectedPlants.length = 0;
        } else {
            $scope.selectedPlants.length = 0;
            for (var i = $scope.plants.length - 1; i >= 0; i--) {
                $scope.selectedPlants.push($scope.plants[i].id);
            }
        }
    };

    $scope.selectedPlantsLabel = function () {
        var length = $scope.selectedPlants.length;
        if (length == 0 || length == $scope.plants.length) {
            return "ALL PLANTS"
        } else if (length == 1) {
            return "ONE PLANT"
        } else {
            return "" + length + " PLANTS"
        }
    };

    $scope.canViewReport = function (obj) {
        return obj.permissions.view_reports;
    };

    // ------------------
    // Watches
    // ------------------
    $scope.$watch('reportOptions.type', function (newVal, oldVal) {
        if (newVal && (newVal != oldVal)) {
            $location.search('type', newVal);
        }
    });

    // ------------------
    // Events
    // ------------------
    $scope.$on("$locationChangeSuccess", function (e, url, oldUrl) {
        $scope.reportOptions.type = $location.search().type || DEFAULT_REPORT;
    });

    // ------------------
    // Fetch Data
    // ------------------
    PlantSvc.list({permissions: 'view_reports'}).then((data) => {
        $scope.plants = data.data;
    });

    PermissionSvc.getPermissions().then(function (result) {
        $scope.permissions = result.data;
    });

    // ------------------
    // Initialization
    // ------------------
    $scope.reportTypes = [
        {label: "Input Forecast", value: "input.2"},
        {label: "Output Forecast", value: "output.2"},
        {label: "Production", value: "production"},
        {label: "Inventory Forecast", value: "production_output"},
        {label: "Day View", value: "dayview"}
    ];

    $scope.reportOptions = {};

    $scope.selectedPlants = [];
}];